import { defineStore } from "pinia";

import { format } from "date-fns";

// 日付を指定の形式で返す
const dateTimeFormat = (date) => {
  if (date) {
    const dateObject = new Date(date);
    return format(dateObject, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
  } else {
    return date;
  }
};

export const useCodeStore = defineStore({
  id: "useCodeStore", //ストアの識別子

  //状態を定義
  state: () => ({
    places: [
      { value: "01", text: "桐生" },
      { value: "02", text: "戸田" },
      { value: "03", text: "江戸川" },
      { value: "04", text: "平和島" },
      { value: "05", text: "多摩川" },
      { value: "06", text: "浜名湖" },
      { value: "07", text: "蒲郡" },
      { value: "08", text: "常滑" },
      { value: "09", text: "津" },
      { value: "10", text: "三国" },
      { value: "11", text: "びわこ" },
      { value: "12", text: "住之江" },
      { value: "13", text: "尼崎" },
      { value: "14", text: "鳴門" },
      { value: "15", text: "丸亀" },
      { value: "16", text: "児島" },
      { value: "17", text: "宮島" },
      { value: "18", text: "徳山" },
      { value: "19", text: "下関" },
      { value: "20", text: "若松" },
      { value: "21", text: "芦屋" },
      { value: "22", text: "福岡" },
      { value: "23", text: "唐津" },
      { value: "24", text: "大村" },
    ],
    raceNo: [
      { value: 1, text: "1" },
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
      { value: 5, text: "5" },
      { value: 6, text: "6" },
      { value: 7, text: "7" },
      { value: 8, text: "8" },
      { value: 9, text: "9" },
      { value: 10, text: "10" },
      { value: 11, text: "11" },
      { value: 12, text: "12" },
    ],
    yosoMark: [
      { value: "0", text: "空" },
      { value: "1", text: "◎" },
      { value: "2", text: "○" },
      { value: "3", text: "△" },
      { value: "4", text: "×" },
    ],
    commentKind: [
      { value: "nes_com", text: "熱戦" },
      { value: "ten_com", text: "展望" },
      { value: "mot_com", text: "モーター抽選結果" },
      { value: "zen_com", text: "前検タイム" },
      { value: "win_com", text: "勝利者インタビュー" },
    ],
    toFro: [
      { value: "1", text: "レース前" },
      { value: "2", text: "レース後" },
      { value: "0", text: "その他" },
    ],
    category: [
      { value: "01", text: "公式ニュース" },
      { value: "02", text: "ゲンダイニュース" },
      { value: "03", text: "コラム" },
      { value: "04", text: "動画" },
    ],
    newIcon: [
      { value: "01", text: "8時間" },
      { value: "02", text: "12時間" },
      { value: "03", text: "24時間" },
      { value: "04", text: "48時間" },
    ],
  }),

  //状態から派生した値を取得するためのゲッター
  getters: {
    getPlaces(state) {
      return state.places;
    },
    getRaceNo(state) {
      return state.raceNo;
    },
    getYosoMark(state) {
      return state.yosoMark;
    },
    getCommentKind(state) {
      return state.commentKind;
    },
    getToFro(state) {
      return state.toFro;
    },
    getCategory(state) {
      return state.category;
    },
    getNewIcon(state) {
      return state.newIcon;
    },
  },

  actions: {
    formatDateTime(date) {
      return dateTimeFormat(date);
    },
  },
});
